module.exports = __webpack_public_path__ + "e012d88f6c1355f3d2cff216c5b2b975.png";